import { useMemo } from 'react'
import { BuyDownloadButtonCSV, BuyDownloadButtonPDF, BuyDownloadPdfTemplateButton, BuyDownloadTags, BuyPdfPreview, BuySupplierPdfPreview } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout/BuyButtons'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { BuyDeliveryNoteDuplicateButton } from '../../../BuyDeliveryNoteButtons'
import { OrderDivideIntoChaptersButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'

const BuyDeliveryNoteCreateNoPermissionButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useBuyDeliveryNoteCreateNoPermissionsStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

const useBuyDeliveryNoteCreateNoPermissionsStepButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'buy_delivery_note_create_no_permissions_step_buttons'
    const Order = data?.header
    const showButtonsByPricesPermission = !data?.header?.hidePrices

    const defaultButtons = [{ "id": "previewBuyDeliveryNotePDF" }, { "id": "downloadBuyDeliveryNote" }, { "id": "duplicateBuyDeliveryNote" }]

    const buyDeliveryNoteDuplicateText = t('duplicateBuyDeliveryNote', 'Duplicar albarán de compra')
    const buyDeliveryNoteDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const buyDeliveryNoteDownloadTagsText = t('printTags', 'Imprimir etiquetas')
    const buyDeliveryNotePreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const buyDeliveryNoteDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const buyDeliveryNoteDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const buyDeliveryNoteDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const buyOrderPreviewSupplierPDFText = t('previewSupplierPDF', 'Previsualizar PDF proveedor')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            duplicateBuyDeliveryNote: {
                component: BuyDeliveryNoteDuplicateButton,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: buyDeliveryNoteDuplicateText,
                    id: 'duplicateBuyDeliveryNote',
                    allRowData: data,
                    permissionTy: 'buy.deliveryNote',
                }
            },
            downloadBuyCsv: {
                component: BuyDownloadButtonCSV,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: buyDeliveryNoteDownloadCSVText,
                    id: 'downloadBuyCsv',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            downloadBuyTag: {
                component: BuyDownloadTags,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: buyDeliveryNoteDownloadTagsText,
                    id: 'downloadBuyTag',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            previewBuySupplierPDF: {
                component: BuySupplierPdfPreview,
                showButton: Order.supplierPdf?.length,
                extraProps: {
                    title: buyOrderPreviewSupplierPDFText,
                    id: 'previewBuyOrderPDFSupplier',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'previewBuyOrderPDFSupplier'
                }
            },
            previewBuyDeliveryNotePDF: {
                component: BuyPdfPreview,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: buyDeliveryNotePreviewPDFText,
                    id: 'previewBuyDeliveryNotePDF',
                    key: 'previewBuyDeliveryNotePDF',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            downloadBuyDeliveryNoteTemplate: {
                component: BuyDownloadPdfTemplateButton,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: buyDeliveryNoteDownloadPDFTemplateText,
                    id: 'downloadBuyDeliveryNoteTemplate',
                    key: 'downloadBuyDeliveryNoteTemplate',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            downloadBuyDeliveryNote: {
                component: BuyDownloadButtonPDF,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: buyDeliveryNoteDownloadPDFText,
                    id: 'downloadBuyDeliveryNote',
                    Order,
                    typeTemplate: 'buyDeliveryNote'
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: buyDeliveryNoteDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [Order, data, onSubmit, buyDeliveryNoteDivideIntoChaptersText, buyDeliveryNoteDownloadCSVText, buyDeliveryNoteDownloadPDFTemplateText, buyDeliveryNoteDownloadPDFText, buyDeliveryNoteDownloadTagsText, buyDeliveryNoteDuplicateText, buyDeliveryNotePreviewPDFText, isReadOnly, showButtonsByPricesPermission, buyOrderPreviewSupplierPDFText])

    return { name, ButtonComponents, defaultButtons }
}

export const BuyDeliveryNoteCreateNoPermissionButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useBuyDeliveryNoteCreateNoPermissionsStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

export default BuyDeliveryNoteCreateNoPermissionButtons